export const HOSPITAL_INFO_KEYWORDS = [
  "EE",
  "PO",
  "SS",
  "AO",
  "A.O",
  "A.O.",
  "AUOP",
  "A.U.O.P",
  "A.U.O.P.",
  "AOU",
  "A.O.U",
  "A.O.U.",
  "UO",
  "U.O",
  "U.O.",
  "UOSD",
  "U.O.S.D",
  "U.O.S.D.",
  "AORN",
  "A.O.R.N",
  "A.O.R.N.",
  "IRCSS",
  "I.R.C.S.S",
  "I.R.C.S.S.",
  "SMM",
  "S.M.M",
  "S.M.M.",
  "COQ",
  "C.O.Q",
  "C.O.Q.",
  "ASL",
  "A.S.L",
  "A.S.L.",
  "UOC",
  "U.O.C",
  "U.O.C.",
  "UOS",
  "U.O.S",
  "U.O.S.",
  "SPDC",
  "S.P.D.C",
  "S.P.D.C.",
  "UTIC",
  "U.T.I.C",
  "U.T.I.C.",
  "PS",
  "P.S",
  "P.S.",
  "DEA",
  "D.E.A",
  "D.E.A.",
  "RSA",
  "R.S.A",
  "R.S.A.",
  "ADI",
  "A.D.I",
  "A.D.I.",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
  "XIII",
  "XIV",
  "XV",
  "XVI",
  "XVII",
  "XVIII",
  "XIX",
  "XX",
  "XXI",
  "XXII",
  "XXIII",
  "XXIV",
  "XXV",
  "XXVI",
  "XXVII",
  "XXVIII",
  "XXIX",
  "XXX",
];